import { Pipe, PipeTransform } from "@angular/core";
import IOrgNode from "@skills-app/models/orgNode";

@Pipe({
  standalone: false,
  name: "orgDisplay",
})
export class OrgDisplayPipe implements PipeTransform {
  transform(org: IOrgNode) {
    return org && org.Id !== null ? org.Name : "";
  }
}
